import { render } from "./DiffModal.vue?vue&type=template&id=189cab25"
import script from "./DiffModal.vue?vue&type=script&lang=js"
export * from "./DiffModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__